const rest = {
  // auth
  LOGIN: '/auth/login',
  LOGOUT: '/auth/logout',
  REGISTER: '/auth/register',
  FORGOT_PASSWORD: '/auth/password:request',
  NEW_PASSWORD: '/auth/password:submit',
  EMAIL_AVAILABILITY: '/auth/email:available',
  PHONE_NUMBER_AVAILABILITY: '/auth/phone-number:available',
  CHANGE_PASSWORD: (userId) => {
    return `/users/${userId}/password-change`;
  },
  SWITCH_TEAM: '/auth/switchteam',

  // social media integration
  OAUTH_TWITTER: '/oauth/twitter',
  OAUTH_TWITTER_AD_ACCOUNT: '/oauth/twitter/adaccount',
  OAUTH_INSTAGRAM: '/oauth/facebook/instagram',
  OAUTH_INSTAGRAM_LOGIN: '/oauth/instagram',
  OAUTH_FACEBOOK_PERSONAL: '/oauth/facebook',
  OAUTH_FACEBOOK_PERSONAL_ADD_ACCOUNT: '/oauth/adaccount',
  OAUTH_FACEBOOK_PAGE: '/oauth/facebook/pages',
  OAUTH_FACEBOOK_GET_PAGES: '/oauth/pages',

  // files
  UPLOAD_REQUEST: '/documents:upload',
  DOWNLOAD_REQUEST: '/documents:download',

  // regions
  PROVINCES: '/region/provinces',
  DISTRICTS: '/region/districts',
  SUBDISTRICTS: '/region/subdistricts',
  VILLAGES: '/region/villages',

  // twitter sdk
  TWITTER_UPLOAD_MEDIA: '/twitter-sdk/upload',

  // facebook upload image
  FACEBOOK_UPLOAD_AD_IMAGE: '/facebook-ads/upload',
};

export default rest;
